import React from 'react'

const UserPage = () => {
    return <div>Hola soy la pagina de usuario</div>
}

export default UserPage
